import React from 'react'
import { GatsbyBrowser } from 'gatsby'

import Layout from './Layout'

function WrapPageElement({ element }: GatsbyBrowser['wrapPageElement']) {
  return <Layout>{element}</Layout>
}

export default WrapPageElement
